
export const okinawaConfig = {
    stepFormLabels: {
        step0: {
            dataViewLabel: 'EF_StepForm_Step0-転職意欲',
            dataClickLabels: {
                high: 'EF_StepForm_Step0-転職意欲-転職したい',
                moderate: 'EF_StepForm_Step0-転職意欲-情報収集',
                close: 'EF_StepForm_Step0-閉じる',
                blank: 'EF_StepForm_Step0-空白',
            }
        },
        step1: {
            dataViewLabel: 'EF_StepForm_Step1-現在の状況',
            dataClickLabels: {
                working: 'EF_StepForm_Step1-現在の状況-在籍中',
                unemployed: 'EF_StepForm_Step1-現在の状況-離職中',
            }
        },
        step2: {
            dataViewLabel: 'EF_StepForm_Step2-経験年数',
            dataClickLabels: {
                lessThan1: 'EF_StepForm_Step2-経験年数-1年未満',
                oneToFive: 'EF_StepForm_Step2-経験年数-1~5年',
                fiveToTen: 'EF_StepForm_Step2-経験年数-5~10年',
                moreThan10: 'EF_StepForm_Step2-経験年数-10年以上',
                back: 'EF_StepForm_Step2-経験年数-戻る'
            }
        },
        step3: {
            dataViewLabel: 'EF_StepForm_Step3-お住まい',
            dataClickLabels: {
                back: 'EF_StepForm_Step3-お住まい-戻る',
                next: 'EF_StepForm_Step3-お住まい-次へ'
            }
        },
        step4: {
            dataViewLabel: 'EF_StepForm_Step4-名前年齢',
            dataClickLabels: {
                back: 'EF_StepForm_Step4-名前年齢-戻る',
                next: 'EF_StepForm_Step4-名前年齢-次へ'
            }
        },
        step5: {
            dataViewLabel: 'EF_StepForm_Step5-連絡先',
            dataClickLabels: {
                back: 'EF_StepForm_Step5-連絡先-戻る',
                link: 'EF_StepForm_Step5-連絡先-Link-利用規約',
                cta: 'EF_StepForm_Step5-連絡先-CVボタン'
            }
        },
    },
}

export default okinawaConfig
